import { cn } from 'utils';

export const styles = {
  camerasList: cn(
    'odin-flex',
    'odin-flex-row',
    'odin-gap-2',
    'odin-order-2',
    'odin-overflow-x-auto',
    'odin-overflow-y-hidden',
    'odin-w-full',
    'lg:odin-flex-col',
    'lg:odin-overflow-x-hidden',
    'lg:odin-overflow-y-auto',
    'lg:odin-order-1',
    'lg:odin-w-[240px]',
  ),
  camerasListItem: cn(
    'odin-h-auto',
    'odin-min-h-[100px]',
    'odin-min-w-[160px]',
    'lg:odin-min-h-[132px]',
    'lg:odin-w-full',
  ),
  mainCamera: cn(
    'odin-bg-odin-black',
    'odin-flex',
    'odin-flex-1',
    'odin-flex-col',
    'odin-items-center',
    'odin-justify-center',
    'odin-order-1',
    'odin-overflow-hidden',
    'odin-rounded-md',
    'lg:odin-order-2',
  ),
  root: cn(
    'odin-flex',
    'odin-flex-col',
    'odin-gap-4',
    'odin-order-1',
    'odin-overflow-hidden',
    'lg:odin-flex-row',
    'xl:odin-col-span-1',
  ),
};
